import { render, staticRenderFns } from "./anomalyOrder.vue?vue&type=template&id=494a95ce&scoped=true"
import script from "./anomalyOrder.vue?vue&type=script&lang=js"
export * from "./anomalyOrder.vue?vue&type=script&lang=js"
import style0 from "./anomalyOrder.vue?vue&type=style&index=0&id=494a95ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a95ce",
  null
  
)

export default component.exports